module.exports = __webpack_public_path__ + "img/juuqo-icon-white.4c5e36da.png";